//搜索Columns
// import BASE_API from '@/api/dataBase';
// import COMPANY_API from '@/api/dataBase';

export const searchColumns = (ctx) => {
  return [
    // {
    //   prop: 'createDepartmentName',
    //   name: '创建组织',
    //   type: 'treeSelect',
    //   apiUrl: BASE_API.LIST_COMPANY_DEPT_TREE,
    //   multiple: true,
    //   isName: true, // 是否返回名字
    //   returnType: 'object', // 全部返回当前对象
    //   changeMethod: 'createDepartmentChange',
    //   ref: 'createDepartmentName',
    //   // currentValue: '7024', // 默认选中的
    //   apiData: {
    //     tenantCode: ctx.userInfo.tenantCode,
    //     adminFlag: ctx.userInfo.adminFlag,
    //     // selfCompanyDepartmentTreeFlag: true,
    //   },
    // },
    // {
    //   prop: 'saleDepartmentName',
    //   name: '销售组织',
    //   type: 'treeSelect',
    //   apiUrl: BASE_API.LIST_COMPANY_DEPT_TREE,
    //   multiple: true,
    //   isName: true, // 是否返回名字
    //   returnType: 'object', // 全部返回当前对象
    //   changeMethod: 'saleDepartmentChange',
    //   ref: 'saleDepartmentName',
    //   // currentValue: '7024', // 默认选中的
    //   apiData: {
    //     tenantCode: ctx.userInfo.tenantCode,
    //     adminFlag: ctx.userInfo.adminFlag,
    //     // selfCompanyDepartmentTreeFlag: true,
    //   },
    // },
    {
      name: '投标抬头',
      prop: 'bidTitles',
      multiple: true,
      type: 'dict',
      dictType: 'INTERMODALITY-SIGN-TITLE',
    },
    {
      name: '投标人员',
      prop: 'bidderId',
      type: 'searchTableSpec',
      searchType: 'personnel',
      changeMethod: 'bidderChange',
      isNeedMultipleValue: true,
    },
    {
      name: '立项申请日期',
      prop: 'applyDate',
      type: 'date',
    },
    {
      name: '项目名称',
      prop: 'projectName',
      type: 'input',
    },
    {
      prop: 'projectCode',
      name: '项目编号',
      type: 'input',
    },
    {
      name: '项目来源',
      prop: 'projectSourceType',
      type: 'select',
      options: [
        { value: 'SWQT', label: '商务洽谈' },
        { value: 'TB', label: '投标' },
        { value: 'OT', label: '其他' },
      ],
    },
    {
      name: '服务类型',
      prop: 'serviceTypeCode',
      type: 'dict',
      dictType: 'INTERMODALITY-SERVICE-TYPE',
      changeMethod: 'serviceTypeChange',
      multiple: true,
      // fixme
    },
    {
      name: '开标日期',
      prop: 'bidOpeningDate',
      type: 'startDaterangePicker',
    },
    {
      name: '截标日期',
      prop: 'bidClosingDate',
      type: 'endDaterangePicker',
    },
    {
      name: '项目开始日期',
      prop: 'projectStartDate',
      type: 'startDaterangePicker',
    },
    {
      name: '项目结束日期',
      prop: 'projectEndDate',
      type: 'endDaterangePicker',
    },
    {
      name: '项目业务类型',
      prop: 'projectBusinessTypeNo',
      type: 'dict',
      dictType: 'mto_business_type',
    },
    // {
    //   prop: 'platformCompanyCode',
    //   name: '平台公司',
    //   type: 'ajaxSelect',
    //   apiUrl: BASE_API.LISTDATA_SERECHCOMPANY + `/${ctx.userInfo.tenantCode}`,
    //   method: 'get',
    //   valueType: 'object',
    //   changeMethod: 'platformCompanyChange',
    // },
    // {
    //   prop: 'platformCompanyName',
    //   name: '平台公司',
    //   type: 'dict',
    //   dictType: 'INTERMODALITY-PLATFORM-COMPANY',
    //   changeMethod:'platformCompanyNameChange'
    // },
    {
      prop: 'platformCompanyCode',
      name: '平台公司',
      type: 'select',
      options: ctx.companyList,
      filterable: true,
      label: 'personCompanyName',
      value: 'personCompanyCode',
      changeMethod: 'platformCompanyNameChange',
    },
    {
      prop: 'createDepartmentNo',
      name: '创建组织',
      type: 'select',
      options: ctx.departmentList,
      changeMethod: 'createDepartmentNoChange',
      // currentValue: ctx.baseInfoData.createDepartmentNo,
      // filterable: true,
      // label: 'personDepartmentName',
      // value: 'personDepartmentCode',
    },
    {
      name: '项目状态',
      prop: 'projectStatus',
      multiple: true,
      type: 'dict',
      changeMethod: 'projectStatusChange',
      dictType: 'INTERMODALITY-PROJECT-STATUS',
    },
    {
      prop: 'projectSort',
      name: '项目分类',
      type: 'select',
      options: [
        { value: 'sp', label: '中小项目' },
        { value: 'bp', label: '重大项目' },
      ],
      placeholder: '请选择项目分类',
    },
  ];
};
